export enum CommonGenericEvents {
	ClickHeader = 'click_header',
	ClickMenu = 'click_menu',
	CloseMenu = 'close_menu',
}
